import { useRef, useState } from "react";

export default function useOtpInput(length = 6) {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputRefs = useRef([]);

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);

    if (value && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text").trim();

    if (!/^[0-9]{6}$/.test(paste)) return;

    const digits = paste.split("");
    setOtp(digits);

    digits.forEach((d, i) => {
      if (inputRefs.current[i]) inputRefs.current[i].value = d;
    });

    inputRefs.current[length - 1].focus();
  };

  return { otp, inputRefs, handleOtpChange, handleKeyDown, handlePaste, setOtp};
}
